import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';

export interface FSRenameEntryAction extends WorkerAction {
  type: FSAction.RenameEntry;
  params: { oldPath: string; newPath: string };
}

class FSRenameEntryActionError extends WorkerActionError {}

export async function FSRenameEntryActionFn({ fs, util, params }: WorkerFnParams<FSRenameEntryAction>): Promise<void> {
  const { oldPath, newPath } = params;
  try {
    console.debug(`[WasmGit]: renaming "${oldPath}" to "${newPath}"`);
    fs.rename(oldPath, newPath);
    await util.syncfs(false);
  } catch (err) {
    throw new FSRenameEntryActionError(err);
  }
}
